const config = {
  theme: 'default'
};

export function getCurrentTheme() {
  return {
    themeName: 'default'
  };
}

export default config;
